import {Component, OnInit} from '@angular/core';
import {PrlAccountDataService} from "../../services/account/prl-account-data.service";
import {MxButtonModel, MxInformationTooltipConfig} from "mx-core";
import {Clipboard} from "@angular/cdk/clipboard";

@Component({
    selector: 'prl-dashboard-refer-friend',
    standalone: false,
    templateUrl: './prl-dashboard-refer-friend.component.html',
    styleUrl: './prl-dashboard-refer-friend.component.scss'
})
export class PrlDashboardReferFriendComponent implements OnInit {
    refererLink: string = '';

    referFriendConfig: MxInformationTooltipConfig = {
        links: [],
        header: 'Help',
        content: 'label.dashboard.refer.friend.help'
    };

    copyButton: MxButtonModel;

    constructor(
        private readonly accountDataService: PrlAccountDataService,
        private readonly clipboard: Clipboard
    ) { }

    ngOnInit(): void {
        this.copyButton = {
            tooltip: 'label.marketing.tools.copy',
            icon: 'content_copy',
            className: 'mxs-button--round mxs-button--primary',
            clickHandler: this.copyLink
        };

        this.accountDataService.getRefererUrl()
            .subscribe((url: string) => {
                this.refererLink = url;
            });
    }

    private copyLink = () => {
        this.clipboard.copy(this.refererLink);
    };
}
